module.exports = __webpack_public_path__ + "img/S3M12_new.ae3dcf9b.jpg";